import { Box, Typography } from '@mui/material';
import {
	HowToBuySvg,
	MyAccountSvg,
	MyOrderSvg,
	PaymentMethodsSvg,
	ReturnsSvg,
	ShippingDeliveriesSvg,
} from '@/components/content/HelpCenter/parts/Icons';
import { CardLink } from '@/components/content/HelpCenter/parts/CardLink';
import {
	HelpCenterDescriptionSx,
	HelpCenterGridSx,
	HelpCenterTitleSx,
} from '@/components/content/HelpCenter/styles/main';
import { useLocalization } from '@/data/Localization';
import React, { useState } from 'react';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';

export const HelpCenter: React.FC<DpContainerProps> = (props) => {
	const [selectedId, setSelectedId] = useState('DPV2HelpCenterMyOrder');

	const handleClick = (id: string) => {
		setSelectedId(id);
	};

	const routes = useLocalization('Routes');

	const links = [
		{
			id: 'DPV2HelpCenterMyOrder',
			name: 'MI PEDIDO',
			href: `/${routes.HelpCenterMyOrder.route.t()}`,
			icon: <MyOrderSvg />,
		},
		{
			id: 'DPV2HelpCenterRefunds',
			name: 'DEVOLUCIONES',
			href: `/${routes.HelpCenterRefunds.route.t()}`,
			icon: <ReturnsSvg />,
		},
		{
			id: 'DPV2HelpCenterDeliveryShipping',
			name: 'ENVÍO Y ENTREGAS',
			href: `/${routes.HelpCenterDeliveryShipping.route.t()}`,
			icon: <ShippingDeliveriesSvg />,
		},
		{
			id: 'DPV2HelpCenterPaymentMethods',
			name: 'FORMAS DE PAGO',
			href: `/${routes.HelpCenterPaymentMethods.route.t()}`,
			icon: <PaymentMethodsSvg />,
		},
		{
			id: 'DPV2HelpCenterHowToBuy',
			name: 'CÓMO COMPRAR',
			href: `/${routes.HelpCenterHowToBuy.route.t()}`,
			icon: <HowToBuySvg />,
		},
		{
			id: 'DPV2HelpCenterMyAccount',
			name: 'MI CUENTA',
			href: `/${routes.HelpCenterMyAccount.route.t()}`,
			icon: <MyAccountSvg />,
		},
	];

	return (
		<DpContainer {...props}>
			<Typography component="h1" sx={HelpCenterTitleSx}>
				{'CENTRO DE AYUDA'}
			</Typography>
			<Typography component="h2" sx={HelpCenterDescriptionSx}>
				{'¿Con qué tema te podemos ayudar? Selecciona una categoría de las opciones aquí debajo.'}
			</Typography>
			<Box sx={HelpCenterGridSx}>
				{links.map(({ name, id, icon }) => (
					<CardLink
						key={name}
						name={name}
						isActive={id === selectedId}
						icon={icon}
						onClick={() => handleClick(id)}
					/>
				))}
			</Box>
			<ContentRecommendation
				id={selectedId}
				properties={{
					emsName: selectedId,
				}}
			/>
		</DpContainer>
	);
};
